import { normalizeTeamKey } from './data.js'

// Shared qualifying-status helpers (used by the /play companion AND the global
// "Start Qualifying" follow pill). Kept in one place so the pending test never
// drifts between them.

// Is this team ALREADY qualified? True if a qualifying score exists in ANY of the
// places a score can land (the qualifying pool, the built team info, or the
// matching registration) — so a team qualified by the app, the web, or staff
// entering the card manually is recognized.
export function teamIsQualified(tournament, teamId, teamInfo) {
  const q = tournament?.qualifying?.[teamId]
  if (q && Number(q.score) > 0) return true
  if (teamInfo?.qualifyingStatus === 'complete') return true
  if (Number.isFinite(Number(teamInfo?.qualifyingScore))) return true
  const want = normalizeTeamKey(teamInfo?.name)
  for (const r of Object.values(tournament?.registrations || {})) {
    const idMatch = r?.teamId && r.teamId === teamId
    const nameMatch = want && normalizeTeamKey(r?.teamName) === want
    if ((idMatch || nameMatch) && (r?.qualifyingStatus === 'complete' || Number.isFinite(Number(r?.qualifyingScore)))) return true
  }
  return false
}

// Is qualifying still open? Open by default, closed only when the pro shop flags
// it or the close window has passed.
export function qualifyingOpen(tournament) {
  const info = tournament?.info || {}
  if (info.qualifyingClosed) return false
  const now = Date.now()
  if (info.qualifyingOpens) { const o = Date.parse(info.qualifyingOpens); if (Number.isFinite(o) && now < o) return false }
  if (info.qualifyingCloses) { const c = Date.parse(info.qualifyingCloses); if (Number.isFinite(c) && now > c + 24 * 60 * 60 * 1000) return false }
  return true
}

// Resolve a team token against a tournament → whether that team may still start
// qualifying. Returns { pending, flightId, teamId, teamName }.
export function pendingForToken(tournament, token) {
  const ref = tournament?.teamTokens?.[token]
  if (!ref?.teamId || !ref?.flightId) return { pending: false }
  const team = tournament?.flights?.[ref.flightId]?.teams?.[ref.teamId]
  const qualified = teamIsQualified(tournament, ref.teamId, team?.info)
  return {
    pending: !qualified && qualifyingOpen(tournament),
    flightId: ref.flightId, teamId: ref.teamId, teamName: ref.teamName || team?.info?.name || '',
  }
}
